import createMetricMetadata from '../factories/index';

class MetricsService {
    constructor({ apiKey, domain, apiUrl, debug }) {
        this.apiKey = apiKey;
        this.domain = domain;
        this.apiUrl = apiUrl || 'https://api.metrical-app.co.uk/collect';
        this.debug = debug;
    }

    pushData(data) {
        window.performanceDataLayer.push(data);
        return;
    }

    postData(payload) {
        const body = JSON.stringify(payload);
        const API_REQUEST = this.apiUrl;
        const requestOptions = {
            method: 'POST',
            body,
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': this.apiKey,
            },
        };
        if (this.debug) {
            console.log('debug()', { url: API_REQUEST, ...requestOptions });
        } else {
            fetch(API_REQUEST, requestOptions).catch((error) => {
                console.error(error);
            });
        }
    }

    track(data) {
        if (data) {
            const metadata = createMetricMetadata();
            const payload = Object.assign({}, data, metadata);
            this.pushData(payload);
        }
        if (!this.isFlushing) {
            this.isFlushing = true;
            window.requestIdleCallback((deadline) => {
                this.flushMetrics(deadline);
                this.isFlushing = false;
            });
        }
    }

    flushMetrics(deadline) {
        if (this.debug) {
            return;
        }

        while (
            (deadline.timeRemaining() > 0 || deadline.didTimeout) &&
            window.performanceDataLayer.length > 0
        ) {
            this.postData(window.performanceDataLayer);
            window.performanceDataLayer = [];
        }
    }
}

export default MetricsService;
